export default __webpack_public_path__ + "static/media/bar2Animation.45ae72a5.svg";